module.exports = __webpack_public_path__ + "98928f16210ce42dce324f9b2d827837.svg";